export const applicationConfig = {
  serviceName: '事業者向けアカウント開設',
  timeeTopUrl: 'https://timee.co.jp/',
} as const;
